import React from "react";
import classnames from 'classnames';

function formatErrorMessage(msg){
  if(!msg) return '';
  if(typeof msg === 'string') return msg;
  if(Array.isArray(msg)) return msg.join(', ');
  if(typeof msg === 'object'){
    if(msg.error) return msg.error;
    if(msg.errors) return flattenErrors(msg.errors);
    return flattenErrors(msg);
  }
  return String(msg);
}

function flattenErrors(errors){
  if(!errors) return '';
  if(typeof errors === 'string') return errors;
  if(Array.isArray(errors)) return errors.join(', ');
  if(typeof errors === 'object'){
    return Object.keys(errors).map(key => {
      const value = errors[key];
      const valueText = Array.isArray(value) ? value.join(', ') : String(value);
      return `${key} ${valueText}`;
    }).join('. ');
  }
  return String(errors);
}

export default ({shouldDisplay, msg}) => {
  if(!shouldDisplay){
    return <div />
  }

  return (
    <div className="notice notice__error">
      <span>{formatErrorMessage(msg)}</span>
    </div>
  )

}

